<template>
  <div class="h-100">
    <alert
      v-if="['success', 'danger', 'pending'].includes(activeAlert.type)"
      :swag="activeAlert.classes"
    >
      <div class="container-fluid d-flex flex-column min-h-100 ">
        <div class="row justify-content-center mt-auto pt-4">
          <div class="col-11 col-sm-10 col-md-6">
            <h1
              :class="
                'poppins-bold ' +
                  (activeAlert.headingClasses ? activeAlert.headingClasses : '')
              "
            >
              {{ activeAlert.title }}
            </h1>
          </div>
        </div>
        <div class="row justify-content-center py-5">
          <div class="col-5">
            <img
              :src="alertIcon(activeAlert.type)"
              width="80%"
              alt="Success Check"
              class="mx-auto alert-icon"
            />
          </div>
        </div>

        <div class="row justify-content-center">
          <div class="col-10 col-md-5 col-lg-4 col-xl-3">
            <p
              :class="
                'text-rem-0-9 ' +
                  (activeAlert.textClasses ? activeAlert.textClasses : '')
              "
            >
              {{ activeAlert.message }}
            </p>
          </div>
        </div>
        <div class="row justify-content-center mt-auto mb-4 mb-md-5 pt-4">
          <div class="col-9 col-md-4 col-lg-3">
            <button class="bg-accent" @click="accept()">
              {{ activeAlert.buttonText ? activeAlert.buttonText : "Aceptar" }}
            </button>
            <!-- <button class="outlined-white">
          Aceptar
        </button> -->
          </div>
        </div>
      </div>
    </alert>
    <alert
      v-if="activeAlert.type == 'ref'"
      :swag="activeAlert.classes + ' mb-2'"
    >
      <a
        class="position-absolute back-arrow-ref d-flex align-content-center mr-auto"
        @click="accept()"
      >
        <img
          class="my-auto"
          src="@/assets/images/icons/back-arrow.svg"
          height="15"
          alt="Go back to menu"
        />
      </a>
      <div class="container-fluid  d-flex flex-column min-h-100 overflow-auto">
        <div class="row justify-content-center mt-auto">
          <div class="col-11 col-sm-10 col-md-6 mt-5">
            <h1 class="h15 poppins-bold" v-html="activeAlert.title"></h1>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-11 col-sm-10 col-md-6 pt-4 px-3 px-md-4">
            <p
              class="text-left text-grey-dark"
              v-html="activeAlert.message"
            ></p>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-11 col-sm-10 col-md-6 pt-4">
            <VuePhoneNumberInput
              class="border-around rounded"
              :only-countries="['CO', 'ES', 'PE', 'MX', 'AR']"
              default-country-code="PE"
              v-model="username"
              @update="updateCountrySelected"
              :translations="{
                countrySelectorLabel: 'País',
                countrySelectorError: 'Escoge un país',
                phoneNumberLabel: 'Teléfono movil',
                example: 'Ejemplo: ',
              }"
            />
          </div>
        </div>
        <div class="row justify-content-center mt-auto mb-4">
          <div class="col-8 col-md-4 px-0 pt-4">
            <whatsapp-Button
              :phone="`${selected_country.phone_code}${username}`"
              :text="
                `Amiga, te invito a que conozcas prepago69.com. Te hacen el 50% de descuento si te registras con este link: https://panel.${apiSettings.app_base}/invitacion/` +
                  user.kProfile
              "
              :buttonlabel="'Invita a una amiga'"
              :buttonClass="
                (isDisabled ? 'disabled ' : '') + 'bg-accent button'
              "
            />
          </div>
        </div>
      </div>
    </alert>
  </div>
</template>

<script>
import settings from "@/api/settings.js"
import WhatsappButton from "@/components/UI/WhatsappButton.vue"

import VuePhoneNumberInput from "vue-phone-number-input"
import Alert from "@/components/UI/Partials/Alert.vue"
import { mapActions, mapGetters } from "vuex"

import { required, minLength } from "vuelidate/lib/validators"
export default {
  data() {
    return {
      apiSettings: settings.apiSettings,
      username: "",
      isDisabled: true,
      selected_country: {
        nombre: "Colombia",
        name: "Colombia",
        nom: "Colombie",
        iso2: "CO",
        iso3: "COL",
        phone_code: 57,
      },
    }
  },
  props: ["activeAlert"],
  components: {
    Alert,
    WhatsappButton,
    VuePhoneNumberInput,
  },
  computed: {
    ...mapGetters(["user", "countries"]),
  },

  methods: {
    updateCountrySelected(event) {
      const locombia = this.countries.find(c => {
        return c.iso2 == event.countryCode
      })
      this.selected_country = locombia
      console.log(locombia)
    },
    ...mapActions(["TOGGLE_ACTIVE_ALERT"]),
    accept() {
      this.TOGGLE_ACTIVE_ALERT().then(status => {
        if (status == true) {
          if (this.$route.path !== this.activeAlert.to.path) {
            this.$router.push(this.activeAlert.to)
          }
        }
      })
    },
    alertIcon(type) {
      if (type == "success") {
        return "/images/icons/green-check.svg"
      } else if (type == "danger") {
        return "/images/icons/red-x.svg"
      } else if (type == "pending") {
        return "/images/icons/white-clock.svg"
      }
    },
  },
  watch: {
    username() {
      this.$v.username.$touch()
      if (this.$v.$invalid) {
        this.isDisabled = true
      } else {
        this.isDisabled = false
      }
    },
  },
  validations() {
    return {
      username: {
        required,
        minLength: minLength(10),
      },
    }
  },
}
</script>

<style lang="scss">
.alert-icon {
  max-width: 200px !important;
}
</style>
